import { useState, useEffect, ReactText } from 'react'

import { closeLoading, showLoading } from '@/utils/utils'
const webapis = (window as { [key: string]: any })['webapis'] as any

export const useGatewayListener = () => {
  const [listenerID, setListenerID] = useState<number>()

  const gatewayListener = () => {
    let toastId = '' as ReactText
    let isError = false
    const id = webapis?.network?.addNetworkStateChangeListener(() => {
      const activeConnectionType = webapis?.network?.getActiveConnectionType()
      const disconnectedType =
        webapis?.network?.NetworkActiveConnectionType?.DISCONNECTED
      if (activeConnectionType === disconnectedType && !toastId) {
        toastId = showLoading(`Couldn't establish network connection`) || ''
        isError = true
      } else if (isError) {
        closeLoading(toastId, 'Connection restored')
        toastId = ''
        isError = false
      }
    })
    setListenerID(id)
  }

  const unregisterGatewayListener = async () => {
    try {
      webapis?.network?.removeNetworkStateChangeListener(listenerID)
      setListenerID(undefined)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  useEffect(() => {
    gatewayListener()
    return () => {
      listenerID && unregisterGatewayListener()
    }
  }, [])
}
